import { useMutation } from "@tanstack/react-query";
import { isOnboardingConversationId } from "features/onboarding/onboarding-script";
import { useConfig } from "./use-config";
import { ConversationResponse, getConversationById, updateConversationById, UpdateConversationPayload } from "services/conversation-services";
import { useGlobalQuery } from "state/query-client/hooks";


interface UpdateConversationVariables {
    payload: UpdateConversationPayload;
    skipInvalidate?: boolean;
}

export const useUpdateConversation = () => {
    const { configurationSettings } = useConfig();
   

    return useMutation({
        mutationFn: ({ payload }: UpdateConversationVariables) =>
            updateConversationById(configurationSettings, payload)
    });
};



export const useGetConversationById = (conversationId: string, isIncognitoChat?: boolean) => {
  const { configurationSettings } = useConfig();
//   isIncognitoChat = isIncognitoChat ?? false;
  return useGlobalQuery<ConversationResponse, Error>({
    queryKey: ['conversation', conversationId],
    queryFn: async () => {
      if (isIncognitoChat) {
        throw new Error('Incognito chats do not have stored conversations');
      }

      if (!conversationId) {
        throw new Error('Conversation ID is required');
      }
      if (!configurationSettings) {
        throw new Error('Configuration settings are not available');
      }
      return await getConversationById(conversationId, configurationSettings, {
        isIncognito: isIncognitoChat,
      });
    },
        enabled: !!conversationId && !isIncognitoChat && !isOnboardingConversationId(conversationId),
  });
};


export const useGetConversationByProjectId = (projectId: string) => {
    const { configurationSettings } = useConfig();
    return useGlobalQuery<ConversationResponse, Error>({
        queryKey: ['getConversationByProjectId', projectId],
        queryFn: async () => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }
            if (!configurationSettings) {
                throw new Error('Configuration settings are not available');
            }
            return await getConversationById(projectId, configurationSettings);
        },
        enabled: !!projectId,
    });
};